const columns = [
  {
    size: 100,
    accessorKey: "subject",
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Oggetto",
  },
  {
    size: 80,
    accessorKey: "user_username",
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Utente",
  },
  {
    size: 80,
    accessorKey: "user_id",
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "ID Utente",
  },
];

export default columns;
